module.exports = __webpack_public_path__ + "static/ec-logo-ed46c8726485be86e476463b9f496720.svg";